import React from 'react';
import { Box, Button } from '@mui/material';
import { Save as SaveIcon, DoDisturb as DoDisturbIcon } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';

export interface EditorActionsProps {
    onSave: () => void;
    onCancel: () => void;
    onDelete?: () => void;
    saveDisabled?: boolean;
    showDelete?: boolean;
    additionalButtons?: React.ReactNode;
}

/**
 * Reusable action buttons bar for editor sidebars
 * Contains Save, Cancel, and optional Delete buttons
 */
const EditorActions: React.FC<EditorActionsProps> = ({
    onSave,
    onCancel,
    onDelete,
    saveDisabled = false,
    showDelete = false,
    additionalButtons
}) => {
    const { t } = useTranslation();

    return (
        <>
            <Button variant="text" startIcon={<SaveIcon />} onClick={onSave} disabled={saveDisabled}>
                <Box sx={{ display: { xs: 'none', md: 'block' } }}>{t('save')}</Box>
            </Button>
            <Button variant="text" startIcon={<DoDisturbIcon />} onClick={onCancel}>
                <Box sx={{ display: { xs: 'none', md: 'block' } }}>{t('cancel')}</Box>
            </Button>
            {additionalButtons}
            {showDelete && onDelete && (
                <Button
                    variant="text"
                    color="error"
                    className="delete"
                    startIcon={<i className="bi bi-trash3" />}
                    onClick={onDelete}
                >
                    <Box sx={{ display: { xs: 'none', md: 'block' } }}>{t('delete')}</Box>
                </Button>
            )}
        </>
    );
};

export default EditorActions;
